import {
  DeliverableGroupKey,
  FeatureLaneModelWithStatus,
  UserSurveyStatusModelForFeatureLane
} from "data/models/feature-lane";
import {Button, Tooltip} from "flowbite-react";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleDot, faCircleCheck} from "@fortawesome/free-solid-svg-icons";
import {faCircle} from "@fortawesome/free-regular-svg-icons";

import {SurveyKey} from "data/models/survey/keys";
import clsx from "clsx";
import {surveyQuestionPath} from "hooks/page-navigation/survey";
import {DeepPartial} from "flowbite-react/dist/types/types";
import {FlowbiteButtonTheme} from "flowbite-react/dist/types/components/Button/Button";
import {useNavigate} from "react-router-dom";

type FeatureLaneBreadCrumbProps = {
  deliverableGroupId: DeliverableGroupKey;
  featureLane: FeatureLaneModelWithStatus;
  currentFeatureSurveyId: SurveyKey;
}

const featureLaneButtonTheme: DeepPartial<FlowbiteButtonTheme> = {
  "size": {
    "lg": "px-0 py-0 text-xs",
  },
};

const ICON_SIZE = "xl";

export default function FeatureLaneBreadCrumb(
    {
      deliverableGroupId,
      featureLane: {id: featureId, title, userSurveys},
      currentFeatureSurveyId
    }: FeatureLaneBreadCrumbProps
) {
  const navigate = useNavigate();
  const currentSurveyIndex = userSurveys.map(us => us.id).indexOf(currentFeatureSurveyId);

  function featureLaneBreadCrumbIcon(userSurvey: UserSurveyStatusModelForFeatureLane, index: number) {
    if (index === currentSurveyIndex) {
      return <FontAwesomeIcon icon={faCircleDot} size={ICON_SIZE} color={"bc-blue"}/>;
    }

    switch (userSurvey.status) {
      case "finished":
        return <FontAwesomeIcon icon={faCircleCheck} size={ICON_SIZE}/>;
      case "in progress":
        return <FontAwesomeIcon icon={faCircle} size={ICON_SIZE}/>;
      case "blocked":
        return <FontAwesomeIcon icon={faCircle} size={ICON_SIZE}/>;
    }
  }

  function buttonClass(userSurvey: UserSurveyStatusModelForFeatureLane, index: number) {
    if (index === currentSurveyIndex) {
      return "text-bc-blue";
    }

    switch (userSurvey.status) {
      case "finished":
        return "text-bc-blue";
      case "in progress":
        return "text-bc-blue";
      case "blocked":
        return "text-neutral-400";
    }
  }

  return <div className={"relative max-w-xs mx-auto flex flex-col my-4 grow"}>
    <div className={"absolute w-full h-full"}>
      <div className={"relative top-2.5 w-full h-1 bg-neutral-50"}></div>
    </div>
    <div className={"grow flex gap-6 flex-row justify-center z-10"}>
      {userSurveys.map(
          (userSurvey, index) => <div key={index} className={"flex flex-row justify-center bg-white w-18"}>
            <Tooltip content={<span>{userSurvey.title}{userSurvey.statusReason !== null &&
                <><br/>{userSurvey.statusReason}</>}</span>}>
              <Button
                  theme={featureLaneButtonTheme}
                  className={clsx("bg-transparent enabled:hover:bg-transparent mx-1 px-0", buttonClass(userSurvey, index))}
                  size="lg"
                  onClick={() => navigate(surveyQuestionPath(
                      deliverableGroupId,
                      featureId,
                      userSurvey.id,
                      "first",
                  ))}
                  disabled={userSurvey.status === 'blocked'}
              >
                {featureLaneBreadCrumbIcon(userSurvey, index)}
              </Button>
            </Tooltip>
          </div>
        )}
    </div>
  </div>

}
